<template>
  <Col gap="sm">
    <Heading4 v-if="title">{{ title }}</Heading4>
    <Row
      v-for="(_, key) in options"
      :key
      items="center"
      gap="xs"
      class="text-deepteal-700 text-sm font-medium"
    >
      <Checkbox
        :id="id + '-' + key"
        v-model="options[key]"
        :value="options[key]"
      ></Checkbox>
      <div class="flex-1 truncate">
        <label :for="id + '-' + key" class="truncate">{{ key }}</label>
      </div>
    </Row>
  </Col>
</template>

<script setup lang="ts">
import { FilterOptions } from "@/views/components/filters/FilterSection.types.";

defineProps<{
  id: string;
  title?: string;
}>();

const options = defineModel<FilterOptions>("options", {
  default: {},
  required: true,
});
</script>
